// extracted by mini-css-extract-plugin
export default {"tabs":"WiCtThH1oV","full-width":"_1Aont3L5Vi","fullWidth":"_1Aont3L5Vi"};
    if(module.hot) {
      // 1648554199079
      var cssReload = require("!../../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  